<div class="user-profile-settings-container no-select">

  <div class="widget-div">

    @if (canOpenOrderSettingsBeViewed) {
      <!-- FILTERS WIDGET -->
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canOpenOrderSettingsBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canOpenOrderSettingsBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Default Filters</div>
          <app-display-icon
            [tooltip]="tooltips.defaultFilters"
            [icon]="icons.infoSlabCircleOutline"
            [colour]="iconColours.secondary">
          </app-display-icon>
        </div>
        <div block>
          <form [formGroup]="formOpenOrderSettings">

            @if (formOpenOrderSettings?.controls['suggestionGreaterThanZero']) {
              <div class="form-column min-width">
                <div class="form-control-div toggle-item">
                  <div class="label">Show Only Suggestions &gt; 0</div>
                  <app-switch-ui
                    id="suggestionGreaterThanZero"
                    [checked]="formOpenOrderSettings?.controls['suggestionGreaterThanZero']?.value ?? false"
                    [disabled]="!canOpenOrderSettingsBeEdited"
                    [size]="0.7"
                    (checkedChange)="onFilterToggleChange('suggestionGreaterThanZero', $event)">
                  </app-switch-ui>
                </div>
              </div>
            }

            @if (formOpenOrderSettings?.controls['orderQuantityGreaterThanZero']) {
              <div class="form-column min-width">
                <div class="form-control-div toggle-item">
                  <div class="label">Show Only Order Qty &gt; 0</div>
                  <app-switch-ui
                    id="orderQuantityGreaterThanZero"
                    [checked]="formOpenOrderSettings?.controls['orderQuantityGreaterThanZero']?.value ?? false"
                    [disabled]="!canOpenOrderSettingsBeEdited"
                    [size]="0.7"
                    (checkedChange)="onFilterToggleChange('orderQuantityGreaterThanZero', $event)">
                  </app-switch-ui>
                </div>
              </div>
            }

            @if (lineColourFilterOptions()) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label>Hide Line Colours</label>
                  <app-shared-custom-select
                    (selectionChange)="onLineColourFilterChange($event)"
                    [allowMultiple]="true"
                    [allowSelectAll]="true"
                    [isDisabled]="!canOpenOrderSettingsBeEdited"
                    [placeholder]="'Select line colours to hide...'"
                    [setOptions]="lineColourFilterOptions()"
                    [showChips]="false">
                  </app-shared-custom-select>
                </div>
              </div>
            }
          </form>
        </div>
        <div actions class="widget-actions" appHorizontalScroll>
          @if (hasOpenOrderSettingsBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canOpenOrderSettingsBeEdited === false"
              (click)="onRevertForm('openOrderSettings')">
              <app-display-icon
                [colour]="canOpenOrderSettingsBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canOpenOrderSettingsBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isOpenOrderSettingsSubmitDisabled"
              (click)="onSubmitForm('openOrderSettings')">
              <app-display-icon
                [colour]="isOpenOrderSettingsSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
          @if (hasOpenOrderSettingsErrors?.length > 0) {
            @for (field of hasOpenOrderSettingsErrors; track $index) {
              <button
                type="button"
                class="error-button">
                <app-display-icon
                  [colour]="iconColours.red"
                  [tooltip]="field?.error"
                  [icon]="icons.alertRhombusOutline">
                </app-display-icon>
              </button>
            }
          }
        </div>
      </app-shared-widget-container-component>

      <!-- ORDER SETTINGS WIDGET -->
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canOpenOrderSettingsBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canOpenOrderSettingsBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Default Order</div>
          <app-display-icon
            [tooltip]="tooltips.defaultOrder"
            [icon]="icons.infoSlabCircleOutline"
            [colour]="iconColours.secondary">
          </app-display-icon>
        </div>
        <div block>
          <form [formGroup]="formOpenOrderSettings">

            @if (formOpenOrderSettings?.controls['inclDaysNegative']) {
              <div class="form-column min-width">
                <div class="form-control-div toggle-item">
                  <div class="label">Include Negative Days</div>
                  <app-switch-ui
                    id="inclDaysNegative"
                    [checked]="formOpenOrderSettings?.controls['inclDaysNegative']?.value ?? false"
                    [disabled]="!canOpenOrderSettingsBeEdited"
                    [size]="0.7"
                    (checkedChange)="onOrderSettingToggleChange('inclDaysNegative', $event)">
                  </app-switch-ui>
                </div>
              </div>
            }

            @if (formOpenOrderSettings?.controls['inclDaysZero']) {
              <div class="form-column min-width">
                <div class="form-control-div toggle-item">
                  <div class="label">Include Zero Days</div>
                  <app-switch-ui
                    id="inclDaysZero"
                    [checked]="formOpenOrderSettings?.controls['inclDaysZero']?.value ?? false"
                    [disabled]="!canOpenOrderSettingsBeEdited"
                    [size]="0.7"
                    (checkedChange)="onOrderSettingToggleChange('inclDaysZero', $event)">
                  </app-switch-ui>
                </div>
              </div>
            }

            @if (formOpenOrderSettings?.controls['mainSupplierItems']) {
              <div class="form-column min-width">
                <div class="form-control-div toggle-item">
                  <div class="label">Main Supplier Items</div>
                  <app-switch-ui
                    id="mainSupplierItems"
                    [checked]="formOpenOrderSettings?.controls['mainSupplierItems']?.value ?? true"
                    [disabled]="!canOpenOrderSettingsBeEdited"
                    [size]="0.7"
                    (checkedChange)="onOrderSettingToggleChange('mainSupplierItems', $event)">
                  </app-switch-ui>
                </div>
              </div>
            }

            @if (formOpenOrderSettings?.controls['meetOrderLevel']) {
              <div class="form-column min-width">
                <div class="form-control-div toggle-item">
                  <div class="label">Meet Order Level</div>
                  <app-switch-ui
                    id="meetOrderLevel"
                    [checked]="formOpenOrderSettings?.controls['meetOrderLevel']?.value ?? false"
                    [disabled]="!canOpenOrderSettingsBeEdited"
                    [size]="0.7"
                    (checkedChange)="onOrderSettingToggleChange('meetOrderLevel', $event)">
                  </app-switch-ui>
                </div>
              </div>
            }

            @if (formOpenOrderSettings?.controls['otherSupplierItems']) {
              <div class="form-column min-width">
                <div class="form-control-div toggle-item">
                  <div class="label">Other Supplier Items</div>
                  <app-switch-ui
                    id="otherSupplierItems"
                    [checked]="formOpenOrderSettings?.controls['otherSupplierItems']?.value ?? false"
                    [disabled]="!canOpenOrderSettingsBeEdited"
                    [size]="0.7"
                    (checkedChange)="onOrderSettingToggleChange('otherSupplierItems', $event)">
                  </app-switch-ui>
                </div>
              </div>
            }

            @if (formOpenOrderSettings?.controls['packSize']) {
              <div class="form-column min-width">
                <div class="form-control-div toggle-item">
                  <div class="label">Show Pack Size</div>
                  <app-switch-ui
                    id="packSize"
                    [checked]="formOpenOrderSettings?.controls['packSize']?.value ?? false"
                    [disabled]="!canOpenOrderSettingsBeEdited"
                    [size]="0.7"
                    (checkedChange)="onOrderSettingToggleChange('packSize', $event)">
                  </app-switch-ui>
                </div>
              </div>
            }

            @if (formOpenOrderSettings?.controls['showLineColours']) {
              <div class="form-column min-width">
                <div class="form-control-div toggle-item">
                  <div class="label">Show Line Colours</div>
                  <app-switch-ui
                    id="showLineColours"
                    [checked]="formOpenOrderSettings?.controls['showLineColours']?.value ?? true"
                    [disabled]="!canOpenOrderSettingsBeEdited"
                    [size]="0.7"
                    (checkedChange)="onOrderSettingToggleChange('showLineColours', $event)">
                  </app-switch-ui>
                </div>
              </div>
            }

            @if (formOpenOrderSettings?.controls['subtractPurchaseOrders']) {
              <div class="form-column min-width">
                <div class="form-control-div toggle-item">
                  <div class="label">Subtract Purchase Orders</div>
                  <app-switch-ui
                    id="subtractPurchaseOrders"
                    [checked]="formOpenOrderSettings?.controls['subtractPurchaseOrders']?.value ?? true"
                    [disabled]="!canOpenOrderSettingsBeEdited"
                    [size]="0.7"
                    (checkedChange)="onOrderSettingToggleChange('subtractPurchaseOrders', $event)">
                  </app-switch-ui>
                </div>
              </div>
            }

          </form>
        </div>
        <div actions class="widget-actions" appHorizontalScroll>
          <button
            type="button"
            class="action-button"
            [disabled]="!canOpenOrderSettingsBeEdited"
            (click)="onResetToDefaultClick()">
            <app-display-icon
              [colour]="!canOpenOrderSettingsBeEdited ? iconColours.disabled : iconColours.red"
              [tooltip]="'Reset to default values'"
              [icon]="icons.backSpaceOutline">
            </app-display-icon>
          </button>
          @if (hasOpenOrderSettingsBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canOpenOrderSettingsBeEdited === false"
              (click)="onRevertForm('openOrderSettings')">
              <app-display-icon
                [colour]="canOpenOrderSettingsBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canOpenOrderSettingsBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isOpenOrderSettingsSubmitDisabled"
              (click)="onSubmitForm('openOrderSettings')">
              <app-display-icon
                [colour]="isOpenOrderSettingsSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
          @if (hasOpenOrderSettingsErrors?.length > 0) {
            @for (field of hasOpenOrderSettingsErrors; track $index) {
              <button
                type="button"
                class="error-button">
                <app-display-icon
                  [colour]="iconColours.red"
                  [tooltip]="field?.error"
                  [icon]="icons.alertRhombusOutline">
                </app-display-icon>
              </button>
            }
          }
        </div>
      </app-shared-widget-container-component>

      <!-- EXPORT SETTINGS WIDGET -->
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canOpenOrderSettingsBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canOpenOrderSettingsBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Default Export Settings</div>
          <app-display-icon
            [tooltip]="tooltips.defaultExportSettings"
            [icon]="icons.infoSlabCircleOutline"
            [colour]="iconColours.secondary">
          </app-display-icon>
        </div>
        <div block>
          <form [formGroup]="formOpenOrderSettings">

            <!-- Note: Column selection to be implemented -->
            <div class="form-column min-width">
              <div class="form-control-div">
                <label>Export Columns</label>
                <app-shared-custom-select
                  (selectionChange)="onAoExportChange($event)"
                  [allowMultiple]="true"
                  [allowSelectAll]="true"
                  [placeholder]="'Select export columns...'"
                  [searchPlaceholder]="'Search columns...'"
                  [selected]="aoExportSelectedKeys"
                  [setOptions]="aoExportOptions"
                  [showChips]="false"
                  [showSearchBar]="true">
                </app-shared-custom-select>
              </div>
            </div>
            @if (formOpenOrderSettings?.controls['exportQtyGreaterThanZero']) {
              <div class="form-column min-width">
                <div class="form-control-div toggle-item">
                  <div class="label">Export Only Qty &gt; 0</div>
                  <app-switch-ui
                    [checked]="formOpenOrderSettings?.controls['exportQtyGreaterThanZero']?.value ?? false"
                    [disabled]="!canOpenOrderSettingsBeEdited"
                    [size]="0.7"
                    (checkedChange)="onExportQtyToggleChange($event)">
                  </app-switch-ui>
                </div>
              </div>
            }

          </form>
        </div>
        <div actions class="widget-actions" appHorizontalScroll>
          @if (hasOpenOrderSettingsBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canOpenOrderSettingsBeEdited === false"
              (click)="onRevertForm('openOrderSettings')">
              <app-display-icon
                [colour]="canOpenOrderSettingsBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canOpenOrderSettingsBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isOpenOrderSettingsSubmitDisabled"
              (click)="onSubmitForm('openOrderSettings')">
              <app-display-icon
                [colour]="isOpenOrderSettingsSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
          @if (hasOpenOrderSettingsErrors?.length > 0) {
            @for (field of hasOpenOrderSettingsErrors; track $index) {
              <button
                type="button"
                class="error-button">
                <app-display-icon
                  [colour]="iconColours.red"
                  [tooltip]="field?.error"
                  [icon]="icons.alertRhombusOutline">
                </app-display-icon>
              </button>
            }
          }
        </div>
      </app-shared-widget-container-component>

<!--      &lt;!&ndash; AUTO-ORDERING SETTINGS WIDGET &ndash;&gt;-->
<!--      <app-shared-widget-container-component>-->
<!--        <div title class="widget-div-heading">-->
<!--          <app-display-icon-->
<!--            [tooltip]="canOpenOrderSettingsBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"-->
<!--            [icon]="canOpenOrderSettingsBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">-->
<!--          </app-display-icon>-->
<!--          <div>Default Order Formula</div>-->
<!--        </div>-->
<!--        <div block>-->
<!--          <form [formGroup]="formOpenOrderSettings">-->

<!--            @if (formOpenOrderSettings?.controls['stockDays']) {-->
<!--              <div class="form-column min-width">-->
<!--                <div class="form-control-div">-->
<!--                  <label for="stockDays" class="required-field">Stock Days</label>-->
<!--                  <input-->
<!--                    [class.invalid]="formOpenOrderSettings?.controls['stockDays']?.errors"-->
<!--                    [formControlName]="'stockDays'"-->
<!--                    id="stockDays"-->
<!--                    placeholder="Days of stock to maintain (0-255)"-->
<!--                    type="number"-->
<!--                    min="0"-->
<!--                    max="255"-->
<!--                    (blur)="validateField('stockDays', $event)"/>-->
<!--                </div>-->
<!--              </div>-->
<!--            }-->

<!--            @if (formOpenOrderSettings?.controls['growth']) {-->
<!--              <div class="form-column min-width">-->
<!--                <div class="form-control-div">-->
<!--                  <label for="growth" class="required-field">Growth Estimation (%)</label>-->
<!--                  <input-->
<!--                    [class.invalid]="formOpenOrderSettings?.controls['growth']?.errors"-->
<!--                    [formControlName]="'growth'"-->
<!--                    id="growth"-->
<!--                    placeholder="Expected growth percentage (-255 to 255)"-->
<!--                    type="number"-->
<!--                    min="-255"-->
<!--                    max="255"-->
<!--                    (blur)="validateField('growth', $event)"/>-->
<!--                </div>-->
<!--              </div>-->
<!--            }-->

<!--            @if (formOpenOrderSettings?.controls['monthsHistory']) {-->
<!--              <div class="form-column min-width">-->
<!--                <div class="form-control-div">-->
<!--                  <label for="monthsHistory" class="required-field">Months of History</label>-->
<!--                  <input-->
<!--                    [class.invalid]="formOpenOrderSettings?.controls['monthsHistory']?.errors"-->
<!--                    [formControlName]="'monthsHistory'"-->
<!--                    id="monthsHistory"-->
<!--                    placeholder="Months to analyze (minimum 1)"-->
<!--                    type="number"-->
<!--                    min="1"-->
<!--                    (blur)="validateField('monthsHistory', $event)"/>-->
<!--                </div>-->
<!--              </div>-->
<!--            }-->

<!--            @if (formOpenOrderSettings?.controls['period']) {-->
<!--              <div class="form-column min-width">-->
<!--                <div class="form-control-div">-->
<!--                  <label for="period" class="required-field">Ordering Method</label>-->
<!--                  <select-->
<!--                    [class.invalid]="formOpenOrderSettings?.controls['period']?.errors"-->
<!--                    [formControlName]="'period'"-->
<!--                    id="period"-->
<!--                    (change)="validateField('period', $event)">-->
<!--                    <option value="1">Seasonal</option>-->
<!--                    <option value="2">Max</option>-->
<!--                    <option value="3">Last X Months</option>-->
<!--                  </select>-->
<!--                </div>-->
<!--              </div>-->
<!--            }-->

<!--          </form>-->
<!--        </div>-->
<!--        <div actions class="widget-actions" appHorizontalScroll>-->
<!--          @if (hasOpenOrderSettingsBeenEdited) {-->
<!--            <button-->
<!--              type="button"-->
<!--              class="action-button"-->
<!--              [disabled]="canOpenOrderSettingsBeEdited === false"-->
<!--              (click)="onRevertForm('openOrderSettings')">-->
<!--              <app-display-icon-->
<!--                [colour]="canOpenOrderSettingsBeEdited === false ? iconColours.disabled : iconColours.secondary"-->
<!--                [tooltip]="tooltips.undoChanges"-->
<!--                [icon]="icons.undo">-->
<!--              </app-display-icon>-->
<!--            </button>-->
<!--          }-->
<!--          @if (canOpenOrderSettingsBeSubmitted) {-->
<!--            <button-->
<!--              type="button"-->
<!--              class="action-button"-->
<!--              [disabled]="isOpenOrderSettingsSubmitDisabled"-->
<!--              (click)="onSubmitForm('openOrderSettings')">-->
<!--              <app-display-icon-->
<!--                [colour]="isOpenOrderSettingsSubmitDisabled ? iconColours.disabled : iconColours.secondary"-->
<!--                [tooltip]="tooltips.saveChanges"-->
<!--                [icon]="icons.contentSaveOutline">-->
<!--              </app-display-icon>-->
<!--            </button>-->
<!--          }-->
<!--          @if (hasOpenOrderSettingsErrors?.length > 0) {-->
<!--            @for (field of hasOpenOrderSettingsErrors; track $index) {-->
<!--              <button-->
<!--                type="button"-->
<!--                class="error-button">-->
<!--                <app-display-icon-->
<!--                  [colour]="iconColours.red"-->
<!--                  [tooltip]="field?.error"-->
<!--                  [icon]="icons.alertRhombusOutline">-->
<!--                </app-display-icon>-->
<!--              </button>-->
<!--            }-->
<!--          }-->
<!--        </div>-->
<!--      </app-shared-widget-container-component>-->

    } @else {
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon [icon]="icons.lockClosedOutline"></app-display-icon>
          <div>Access Denied</div>
        </div>
        <div block>
          <p>You do not have permission to view open order settings.</p>
        </div>
      </app-shared-widget-container-component>
    }

  </div>

  <div class="ups-container-action-bar widget-actions">
    <button
      [disabled]="!haveAnyEditsBeenMade"
      type="button"
      class="action-button"
      (click)="onRevertForm('all')">
      <app-display-icon
        [colour]="iconColours.secondary"
        [tooltip]="tooltips.undoAllChanges"
        [icon]="icons.undo">
      </app-display-icon>
      Undo Changes
    </button>
    <button
      [disabled]="!haveAnyEditsBeenMade"
      type="button"
      class="action-button"
      (click)="onSubmitForm('openOrderSettings')">
      <app-display-icon
        [colour]="iconColours.secondary"
        [tooltip]="tooltips.saveAllChanges"
        [icon]="icons.contentSaveOutline">
      </app-display-icon>
      Save All
    </button>
  </div>
</div>
